import {createAction, props} from '@ngrx/store';
import {IndicationBasicModel} from '@core/modules/rest/indication/response/indication-basic.model';
import {LanguageEnum} from '@core/enums/language.enum';
import {IndicationModel} from '@core/modules/rest/indication/response/indication.model';
import {IndicationBasicStatusCodeModel} from '@core/modules/rest/indication/response/indication-basic-status-code.model';

export const GetIndications = createAction(
    '[Indication] Get all indications',
    props<{ language: LanguageEnum }>()
);

export const GetIndicationsSuccess = createAction(
    '[Indication] Get all indications success',
    props<{ indications: IndicationBasicModel[] }>()
);

export const GetIndication = createAction(
    '[Indication] Get indication',
    props<{ id: string, language: LanguageEnum }>()
);

export const GetIndicationSuccess = createAction(
    '[Indication] Get indication success',
    props<{ indication: IndicationBasicModel }>()
);

export const CloneIndication = createAction(
    '[Indication] Clone indication',
    props<{ indicationId: string, language: LanguageEnum, executed: () => void }>()
);

export const CloneIndicationSuccess = createAction(
    '[Indication] Clone indication success',
    props<{ indication: IndicationBasicModel }>()
);

export const SaveIndication = createAction(
    '[Indication] Save indication',
    props<{
        request: IndicationModel, language: LanguageEnum,
        executed: (response: IndicationBasicStatusCodeModel) => void
    }>()
);

export const SaveIndicationSuccess = createAction(
    '[Indication] Save indication success',
    props<{ indication: IndicationBasicModel }>()
);
